/**
 * @fileoverview SPANISH strings for `@puffin-core/captcha-ui`.
 * @package @puffin-core/captcha-ui
 *
 * AAS-I18N-002 W8 / user ruling 25 (2026-08-10). Register is **usted**,
 * ecosystem-wide — `Póngase en contacto`, never `Ponte en contacto`.
 *
 * Machine-translated; every leaf is `machine` in the register ledger. Key set is
 * intentionally identical to `en.js` (no plurals here, so no CLDR `_many`
 * asymmetry applies).
 */

export const CAPTCHA_STRINGS_ES = Object.freeze({
  'captcha.ariaLabel': 'Verificación de seguridad',
  'captcha.ariaLabelDev': 'Verificación de seguridad (modo de desarrollo)',
  'captcha.unavailable.ariaLabel': 'La verificación de seguridad no está disponible',
  'captcha.unavailable.message':
    'La verificación de seguridad no está disponible. Póngase en contacto con el soporte.',
  'captcha.dev.badge': 'DESARROLLO',
  'captcha.dev.bypassed': 'CAPTCHA omitido: defina VITE_TURNSTILE_SITE_KEY para activarlo',
});

export default CAPTCHA_STRINGS_ES;
